import { render, staticRenderFns } from "./SaxxUpload.vue?vue&type=template&id=98a40974"
import script from "./SaxxUpload.vue?vue&type=script&lang=js"
export * from "./SaxxUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports